export const PREDEFINED_SUBTASKS = [
  'VFA (vyšlé faktúry)',
  'DFA (došlé faktúry)',
  'Banka – príjmy aj výdaje',
  'Pokladňa – príjmy aj výdaje',
  'Pohľadávky',
  'Záväzky',
  'ID (interné doklady)',
  'Podanie DPH a KV k DPH',
  'Podanie DP k DPH',
  'Vystavovanie faktúr',
];
